import { render, staticRenderFns } from "./UserAccountProfileSecurity2FASetup.vue?vue&type=template&id=1cf84a7d&scoped=true&"
import script from "./UserAccountProfileSecurity2FASetup.vue?vue&type=script&lang=js&"
export * from "./UserAccountProfileSecurity2FASetup.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountProfileSecurity2FASetup.vue?vue&type=style&index=0&id=1cf84a7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf84a7d",
  null
  
)

export default component.exports